import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const setAuthToken = (token) => {
  if (token) {
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("hipower_admin_token", token);
  } else {
    delete apiClient.defaults.headers.common["Authorization"];
    localStorage.removeItem("hipower_admin_token");
  }
};

const stored = localStorage.getItem("hipower_admin_token");
if (stored) {
  apiClient.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export const getStoredToken = () => localStorage.getItem("hipower_admin_token");
